import pusher_pkg from "pusher-js";
/**
 * The Pusher adapter.
 *
 * Everything above it works against `RealtimeTransport`, which is what lets the
 * registry be tested without a websocket and lets a different runtime — React
 * Native's build of the same client, say — be supplied instead.
 */
/**
 * pusher-js ships CommonJS type declarations, so TypeScript types the default
 * import as the module and refuses to construct it. The runtime value is
 * already the class — only the type needs correcting, which is all this cast
 * does.
 */
const PusherClient = pusher_pkg;
export function buildPusherTransport({ clientKey, cluster, authorise, }) {
    const channelAuthorization = authorise === undefined
        ? undefined
        : {
            customHandler: (params, callback) => {
                authorise(params).then((data) => {
                    callback(null, data);
                }, (error) => {
                    callback(error instanceof Error ? error : new Error(String(error)), null);
                });
            },
        };
    const client = new PusherClient(clientKey, {
        cluster,
        ...(channelAuthorization === undefined ? {} : { channelAuthorization }),
    });
    const transport = {
        subscribe: (channel) => {
            const pusherChannel = client.subscribe(channel);
            const subscription = {
                bind: (event, handler) => {
                    pusherChannel.bind(event, handler);
                },
                unbindAll: () => {
                    pusherChannel.unbind_all();
                },
            };
            return subscription;
        },
        unsubscribe: (channel) => {
            client.unsubscribe(channel);
        },
        // pusher-js re-subscribes its own channels when the socket comes back, so
        // what a listener needs to know is only that events were missed while it
        // was down. The first connection is not a reconnection and must not fire:
        // nothing has been missed, and whoever is watching has just read anyway.
        onReconnect: (listener) => {
            let hasConnected = false;
            const onStateChange = ({ current }) => {
                if (current !== "connected") {
                    return;
                }
                if (hasConnected) {
                    listener();
                }
                hasConnected = true;
            };
            client.connection.bind("state_change", onStateChange);
            return () => {
                client.connection.unbind("state_change", onStateChange);
            };
        },
    };
    return {
        client,
        transport,
        disconnect: () => {
            client.disconnect();
        },
    };
}
//# sourceMappingURL=pusherTransport.js.map